/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { borderRadius } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const BannerContainer = styled.div({
  padding: `0 ${token('space.600')} ${token('space.200')}`,
  marginTop: token('space.300'),
  maxWidth: '536px',
  borderRadius: `${borderRadius()}px`,
  position: 'relative',
  boxShadow: token('elevation.shadow.overlay'),
  '.close-button': {
    position: 'absolute',
    right: token('space.200'),
    top: token('space.100'),
  },
  '& > span': {
    '&:first-child': {
      position: 'absolute',
      top: token('space.150'),
      left: token('space.200'),
    },
  },
});

export const Title = styled.h4({
  display: 'inline-block',
  font: token('font.heading.xsmall'),
  marginTop: token('space.200'),
});

export const Description = styled.div({
  padding: `${token('space.200')} 0`,
});
